import { Server } from '../../server/server';
import { UIDialog } from '../common/ui/uiDialog';
import { UIImage } from '../common/ui/uiImage';
import { UIPanel } from '../common/ui/uiPanel';
import { UIPanelButton } from '../common/ui/uiPanelButton';
import { UIText } from '../common/ui/uiText';
import { Game } from './game';
import { GameStyle } from './gameStyle';
import { PowerupImage, PowerUpType } from './pupListDialog';

export class PupSlotsDialog extends UIDialog {

  popup: UIPanel;
  slot_1_image: UIImage;
  slot_2_image: UIImage;
  slot_3_image: UIImage;

  public build() {
    this.popup = new UIPanel({
      size: {x: 290, y: 270},
      anchor: {x: 0.5, y: 0.45},
      pivot: {x: 0.5, y: 0.5},
      position: {x: 0, y: 0},
      radius: this.options.panel.radius,
      color: this.options.panel.color,
      gradient: this.options.panel.gradient,
      borderColor: this.options.panel.borderColor,
      borderWidth: this.options.panel.borderWidth,
      shadow: this.options.panel.shadow,
      parent: this
    });

    let titleText = new UIText({
      text: 'CHOOSE POWERUPS',
      position: {x: 0, y: 15},
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      horizontalAlign: 'center',
      color: this.options.title.color,
      fontFamily: this.options.title.fontFamily,
      fontSize: this.options.title.fontSize,
      fontWeight: this.options.title.fontWeight,
      shadow: this.options.title.shadow,
      parent: this.popup
    });

    let instructionsText = new UIText({
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      text: 'Select 3 powerups from your\ninventory to bring into the game.',
      position: {x: 0, y: 45},
      horizontalAlign: 'center',
      color: '#ffffff80',
      fontFamily: this.options.message.fontFamily,
      fontSize: this.options.message.fontSize,
      parent: this.popup
    });

    let img_props     = this.setSlotImageProps('20');
    this.slot_1_image = new UIImage(img_props);

    img_props         = this.setSlotImageProps('110');
    this.slot_2_image = new UIImage(img_props);

    img_props         = this.setSlotImageProps('200');
    this.slot_3_image = new UIImage(img_props);

    this.buildSlot(this.slot_1_image, 20, 1);
    this.buildSlot(this.slot_2_image, 110, 2);
    this.buildSlot(this.slot_3_image, 200, 3);

    let playButton = new UIPanelButton({
      text : 'Play',
      anchor : {x : 1, y : 1},
      pivot : {x : 1, y : 1},
      position : {x : -20, y : -20},
      size : {x : 100, y : 40},
      callback : () => {
        this.hide();
        this.callback('back');
      },
      panelColors: this.options.button.panelColors,
      textColors: this.options.button.textColors,
      radius: this.options.button.radius,
      fontFamily: this.options.button.fontFamily,
      fontSize: this.options.button.fontSize,
      textOffset: this.options.button.textOffset,
      borderColor: this.options.button.borderColor,
      borderWidth: this.options.button.borderWidth,
      parent : this.popup
    });

    let clearButton = new UIPanelButton({
      text : 'Clear',
      anchor : {x : 0, y : 1},
      pivot : {x : 0, y : 1},
      position : {x : 20, y : -20},
      size : {x : 100, y : 40},
      callback : () => {
        this.clearSlots();
      },
      panelColors: this.options.button.panelColors,
      textColors: this.options.button.textColors,
      radius: this.options.button.radius,
      fontFamily: this.options.button.fontFamily,
      fontSize: this.options.button.fontSize,
      textOffset: this.options.button.textOffset,
      borderColor: this.options.button.borderColor,
      borderWidth: this.options.button.borderWidth,
      parent : this.popup
    });
  }

  public onWake() {
    // set defaults
    let s = 1;
    if(Server.user.getAssetQuantity('whacka-double-score') > 0)
      localStorage.setItem('whacka-slot-' + (s++), PowerUpType.DoubleScore.toString());
    if(Server.user.getAssetQuantity('whacka-slow-motion') > 0)
      localStorage.setItem('whacka-slot-' + (s++), PowerUpType.SlowMotion.toString());
    if(Server.user.getAssetQuantity('whacka-shields') > 0)
      localStorage.setItem('whacka-slot-' + (s++), PowerUpType.Shields.toString());

    for(let i = s; i <=3; i++)
      localStorage.removeItem('whacka-slot-' + i);

    // normal processing
    let slot_1 = localStorage.getItem('whacka-slot-1');
    let slot_2 = localStorage.getItem('whacka-slot-2');
    let slot_3 = localStorage.getItem('whacka-slot-3');
  
    this.slot_1_image.url = 'null';
    this.slot_2_image.url = 'null';
    this.slot_3_image.url = 'null';

    if (slot_1)
      this.slot_1_image.url = PowerupImage.get(Number(slot_1));
    
    if (slot_2)
      this.slot_2_image.url = PowerupImage.get(Number(slot_2));
    
    if (slot_3)
      this.slot_3_image.url = PowerupImage.get(Number(slot_3));
  }

  protected buildSlot(slotImage: UIImage, x: number, slotIndex:number) {
    let slot_props   = this.setSlotProps(slotImage, x);
    let slot         = new UIPanelButton(slot_props);
    slotImage.parent = slot;

    let slotText = new UIText({
      anchor: {x: 0.5, y: 1},
      pivot: {x: 0.5, y: 0},
      text: 'Slot ' + slotIndex.toString(),
      position: {x: 0, y: 5},
      color: '#ffffff80',
      fontFamily: GameStyle.fonts.small.family,
      fontSize: GameStyle.fonts.small.size,
      parent: slot
    });
  }

  protected selectPowerup(slot: UIImage) {
    let slotNumber = 0;
    if (slot.name == '20')
      slotNumber = 1;
    else if (slot.name == '110')
      slotNumber = 2;
    else if (slot.name == '200')
      slotNumber = 3;

    this.popup.visible = false;

    Game.instance.pupListDialog.setSlotNumber(slotNumber);
    Game.instance.pupListDialog.show((action: number) => {
      if (action !== -1) {
        slot.url = PowerupImage.get(action);
        localStorage.setItem('whacka-slot-' + slotNumber.toString(), action.toString());
      }
      this.popup.visible = true;
    });
  }

  protected setSlotProps(slotImage: UIImage, x: number) {
    let data = {
      panelColors : {normal : '#00000080'},
      radius : 10,
      borderWidth : 2,
      borderColor : '#000000',
      textColors : {normal : '#ffffff'},
      callback : () => {
        this.selectPowerup(slotImage);
      },
      anchor : {x : 0, y : 0},
      pivot : {x : 0, y : 0},
      size : {x : 70, y : 70},
      position : {x : x, y : 105},
      parent : this.popup
    };

    return data;
  }

  protected setSlotImageProps(name: string) {
    let data = {
      name: name,
      url : 'null',
      anchor : {x : 0.5, y : 0.5},
      pivot : {x : 0.5, y : 0.5},
      position : {x : 0, y : 0},
      size : {x : 60, y : 60},
      stretch : true,
      parent : this
    };

    return data;
  }

  protected clearSlots() {
    this.slot_1_image.url = 'null';
    this.slot_2_image.url = 'null';
    this.slot_3_image.url = 'null';

    for(let i = 0; i < 3; i++) 
      localStorage.removeItem('whacka-slot-' + (i+1).toString());
  }
}